require('intersection-observer');

import * as CSSTH from '../../modules/css-transition-helper/css-transition-helper';
import addDelegateEventListener from '../../modules/utility-functions/add-delegate-event-listener';
import { isMobile } from '../mobile-detect/mobile-detect';
import './fake-sticky.scss';

const stickyElement = '.js-sticky-elm';
const triggerElement = '.js-sticky-trigger';


const options = {
    rootMargin: '20%'
};

const addEventListeners = () => {
    const buyGrids = document.querySelectorAll('.buy-grid');
    addDelegateEventListener(document, 'click', '.js-sticky-add-to-bag', event => {
        buyGrids[0].querySelector('.js-add-to-bag').click();
    }, false);
};

const observerCallback = (entries, observer) => {
    const stickyElm = document.querySelector(stickyElement);
    if (!stickyElm) return;
    entries.forEach(entry => {
        if (entry.isIntersecting) {

            CSSTH.deactivate(stickyElm);
        }
        if (!entry.isIntersecting) {
            CSSTH.activate(stickyElm);
        }
    });

};

export const init = () => {
    const triggerElm = document.querySelectorAll(triggerElement);
    const stickyElm = document.querySelectorAll(stickyElement);

    if (!isMobile()) return;
    if (!triggerElm.length) return;
    if (!stickyElm) return; 

    addEventListeners();

    const observer = new IntersectionObserver(observerCallback, options);
    observer.observe(...triggerElm);
};
